import { useTeam, useUserProfile } from './useDataHook'
import { Group } from 'types/entity'

const useCurrentTeam = () => {
  const { data: userProfile } = useUserProfile()
  const { token_id } = userProfile?.teams?.[0] ?? {}
  return useTeam({
    params: {
      teamId: token_id!
    },
    opts: {
      enabled: !!token_id,
      placeholderData: {} as Group
    }
  })
}

export default useCurrentTeam
